export default {
  total: 'Total'
}
